// Styles for OffersTextBlock go here.
import styled from 'styled-components';
import { font, mediaQuery } from '../../utils/styles';

export const StyledOffersTextBlock = styled.div`
  .offer-text-block {
    .custom-text-block {
      padding-top: 3rem;
      padding-bottom: 3rem;

      @media ${mediaQuery.desktop} {
        padding-top: 4rem;
        padding-bottom: 4rem;
      }
    }
    div {
      font-family: ${font.Swiss721BTRegular};
    }
  }
`;
